<template>
  <div class="purpose">
    <!-- <div class="purpose-container"> -->
      <!-- <div class="purpose-container-up"> -->
        <div class="summary">
          <div v-if="hasSI" class="summary-si">
            <div class=summary-title>
              <div class="pl-percentage  si-percentage-circle">
                <div class="pl-text">
                  <div class="pl-name">SuperImpact</div>
                  <div class="pl-number">{{siPercentage}}%</div>
                </div>
                <div class="pl-circle">
                  <div class="pl-info">
                    <Suggestion placement="right-start">
                      <template #suggestContent>
                        <div style="padding:20px;" v-html="options.product_lines.SuperImpact.description"></div>
                      </template>
                      <template #shownElement>
                        <div>
                          <i class="fas fa-info-circle "></i>
                        </div>
                      </template>
                    </Suggestion>
                  </div>
                </div>
              </div>
              <div class="pl-slogan">
                <div v-html="siSummary">
                </div>
                <p v-if="showAdFormatSuggestion">建議使用格式:
                  <Suggestion :visibleArrow="true" trigger="click">
                    <template #suggestContent>
                      <div class="format-suggestion">
                        <div v-for="format in getAdsByType(superImpactformatType)" :key="format.id" class="format-suggestion-item">
                          <img style="height: 100px;" :src="getAdTypeImg(format.title)" alt="">
                          <span>{{ format.title }}</span>
                        </div>
                      </div>
                    </template>
                    <template #shownElement>
                      <!-- <div class="format-info">
                        <i class="fas fa-info-circle"></i>
                      </div> -->
                      <u style="color: #4da1ff;">{{ formatLinkText }}</u>
                    </template>
                  </Suggestion>
                </p>
              </div>
            </div>
            <div class="summary-format">
              <el-row>
                <el-col :span="12" :offset="0" :class="['guide_context']"
                        v-for="item in recommendAdFormatTypes[purposeNumber]"
                        :key="item.ad_format_type_id"
                >
                  <el-row class="" style="">
                    <el-col :span="7" class="guide_result_format">
                      <img :src="getAdTypeImg(item.title)" alt="">
                    </el-col>
                    <el-col :span="17">
                        <span class="guide_result">{{item.title}}</span>
                        <div> {{item.description}}  </div>
                        <el-button  v-for="(link, index) in item.links"
                          :key="index" @click="openDemoUrl(link.link)"
                          style="margin-left:0px;margin-top:4px;"
                          size="mini" type="primary" round>{{getDemoLinkButtonName(link.name, item.links)}}</el-button>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="summary-not-si">
            <div
              id="summary-sv"
              :class="{disabled: !hasSV}"
            >
              <div class=summary-title>
                <div class="pl-percentage sv-percentage-circle">
                  <div class="pl-text">
                    <div class="pl-name">SuperView</div>
                    <div class="pl-number">{{svPercentage}}%</div>
                  </div>
                  <div class="pl-circle">
                    <div class="pl-info">
                      <Suggestion placement="right-start">
                        <template #suggestContent>
                          <div style="padding:20px;" v-html="options.product_lines.SuperView.description"></div>
                        </template>
                        <template #shownElement>
                          <div>
                            <i class="fas fa-info-circle "></i>
                          </div>
                        </template>
                      </Suggestion>
                    </div>
                  </div>
                </div>
                <div class="pl-slogan">
                  <div v-if="hasSV" v-html="svSummary" />
                  <div v-else v-html="textForInvalid('SuperView')" />
                </div>
              </div>
            </div>
            <div
              id="summary-line"
              :class="{disabled: !hasLINE}"
            >
              <div class=summary-title>
                <div class="pl-percentage line-percentage-circle">
                  <div class="pl-text">
                    <div class="pl-name">LINE Today</div>
                    <div class="pl-number">{{linePercentage}}%</div>
                  </div>
                  <div class="pl-circle">
                    <div class="pl-info">
                        <Suggestion placement="right-start">
                          <template #suggestContent>
                            <div style="padding:20px;" v-html="options.product_lines.LINEToday.description"></div>
                          </template>
                          <template #shownElement>
                            <div>
                              <i class="fas fa-info-circle "></i>
                            </div>
                          </template>
                        </Suggestion>
                    </div>
                  </div>
                </div>
                <div class="pl-slogan">
                  <div v-if="hasLINE" v-html="lineSummary" />
                  <div v-else v-html="textForInvalid('LINEToday')" />
                </div>
              </div>
            </div>
            <!-- 如果未來有其它產品線，應由此往下加 -->
          </div>

        </div>
  </div>
</template>
<script>
import { purposeContent, getAdTypeImg, recommendAdFormatTypes } from '@/utils/purposeSummaryContent.js'
import Suggestion from '@/views/Suggestion'
import { mapState } from 'vuex'
export default {
  name: 'PurposeSummary',
  components: {
    Suggestion
  },
  data () {
    return {
      purposeContent,
      recommendAdFormatTypes
    }
  },
  computed: {
    ...mapState('speedCalculation2', ['options']),
    purposeNumber () {
      return 'purpose' + this.purposeState.purposeType.id
    },
    purposeState () {
      return this.$store.state.guide.purpose
    },
    siPercentage () {
      return this.purposeState.purposeType.si_rate * 100
    },
    svPercentage () {
      return this.purposeState.purposeType.sv_rate * 100
    },
    linePercentage () {
      return this.purposeState.purposeType.line_rate * 100
    },
    formatLinkText () {
      return purposeContent[this.purposeNumber].formatLinkText
    },
    superImpactformatType () {
      return purposeContent[this.purposeNumber].formatType
    },
    hasSI () {
      return !!purposeContent[this.purposeNumber].si
    },
    hasSV () {
      return !!purposeContent[this.purposeNumber].sv
    },
    hasLINE () {
      return !!purposeContent[this.purposeNumber].line
    },
    siSummary () {
      return purposeContent[this.purposeNumber].si
    },
    svSummary () {
      return purposeContent[this.purposeNumber].sv
    },
    lineSummary () {
      return purposeContent[this.purposeNumber].line
    },
    showAdFormatSuggestion () {
      return this.options.product_lines.SuperImpact.list && this.formatLinkText
    }
  },
  methods: {
    textForInvalid (productLineName) {
      return `未啟用此產品線<br/>＊您可點擊右下方「將結果帶入計算頁面，快速規劃」按鈕，手動加入 ${productLineName} 之預算配比`
    },
    superImpactAdFormats () {
      return this.options.product_lines.SuperImpact.list[0].ad_format_types
    },
    getAdsByType (typeName) {
      return this.superImpactAdFormats().filter(adFormat => adFormat.name === typeName)
    },
    getAdTypeImg (title) {
      return getAdTypeImg(title)
    },
    openDemoUrl (url) {
      window.open(url, '_blank')
    },
    getDemoLinkButtonName (name, linkArr) {
      if (linkArr.length === 1) {
        return 'DEMO'
      } else {
        return `DEMO: ${name}`
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/adFormat-suggestion.scss';
.summary{
  max-width:800px;
}
.summary-title {
  display: flex;
}
.summary-format {
  margin-left: 48px;
}
.summary-si{
  width:100%;
  min-height:246px;
  margin-bottom:16px;
  background:#ffe7d4;
}
.summary-not-si{
  display: flex;
  align-items: flex-start;
/*   flex-wrap: wrap; */
}
#summary-sv, #summary-line{
  width:50%;
  height:160px;
}
#summary-sv{
  background:#d4e8ff;
  margin-right:8px;
}
#summary-line{
  background:#d8ffd4;
  margin-left:8px;
}
.pl-percentage{
  width:124px;
  height:110px;
  color:#fff;
  overflow:hidden;
  flex-shrink: 0;
}
.pl-slogan {
  flex-basis:auto;
  margin-top: 24px;
  margin-right: 24px;
  margin-left: 24px;
}
.pl-circle{
  width:160px;
  height:160px;
  background:#E1823C;
  border-radius:50%;
  margin-left:-36px;
  margin-top:-50px;

}
.pl-info{
  position:absolute;
  margin-top:49px;
  margin-left:145px;
  text-align:center;
  z-index:1000;
  width:24px;
  height:24px;
  font-size:20px;
  border-radius: 50%;
  color:#E1823C;
  background:#ffe7d4;
  // 子元件置中
  display: flex;
  justify-content: center;
  align-items: center;
}
.pl-text{
  position:absolute;
  display:flex;
  flex-direction:column;
  justify-content: center;
  width:124px;
  text-align:center;
}
.pl-name{
  padding-top:20px;
/*   margin-bottom:-8px; */
  font-size:16px;
  padding-top: 12px;
  padding-right: 12px;
  font-size: 18px;
}
.pl-number{
  font-size:40px;
  font-weight:400;
  padding-right:4px;
}

/* SV、Line的圓顏色設定 */
#summary-sv {
  .pl-circle {
    background:#6799d2;
  }
  .pl-info {
    color:#6799d2;
    background:#d4e8ff;
  }
}
#summary-line {
  .pl-circle {
    background:#57c62d;
  }
  .pl-info {
    color:#57c62d;
    background:#d8ffd4;
  }
}
#summary-sv, #summary-line {
  &.disabled {
    color: #9b9b9b;
    background: #f1f1f1;
    font-size: 15px;
    font-weight: bold;
    .pl-circle {
      background: #c6c6c6;
    }
    .pl-info {
      color:#c6c6c6;
      background:#f1f1f1;
    }
  }
}

.el-button{
  background-color:#E89022;
  border-color:#E89022;
}
.guide_context{
  font-size: 16px;
  line-height: 1.5;
  text-align: left;
  padding: 16px;
}
.guide_result{
  color:#e89022;
  font-weight: bold;
  /* text-decoration: underline; */
}
.guide_result_format{
  text-align: right;
}
.guide_result_format img{
  height:104px;
  margin:0px 0;
  width:auto;
  max-width:100%;
  padding-right:16px;
}
.purpose {
  width: 800px;
}
.el-popover__reference {
  cursor: pointer;
}
</style>
